import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: 'img[imgPlaceholder]',
  standalone: true
})
export class ImgPlaceholderDirective {
  @Input() placeholderLink = '';

  @HostListener('error', ['$event'])
  onError(): void {
    this.el.nativeElement.src = this.placeholderLink || 'https://placehold.co/300x300?text=Image+Not+Found';
  }

  constructor(private el: ElementRef) {}

}
